import Request from '../request'
const request = Request('', '/restaurant')

//用户权限
export function auth(form: object) {
    return request('/user/auth').stream('get', form)
}
